<div class="w-full h-full bg-pattern" fxLayout="column" fxLayoutAlign="center center">
  <div @fadeInUp class="card overflow-hidden w-full max-w-xs">
    <div class="p-6 pb-0" fxLayout="column" fxLayoutAlign="center center">
      <div class="fill-current text-center">
        <img class="w-16" src="assets/img/demo/logo.svg">
      </div>
    </div>

    <div class="text-center mt-4">
      <h2 class="title m-0">Welcome back</h2>
      <h4 class="body-2 text-secondary m-0">Sign in with your credentials below.</h4>
    </div>

    <div [formGroup]="form" class="p-6" fxLayout="column" fxLayoutGap="16px">
      <div fxFlex="auto" fxLayout="column">
        <mat-form-field fxFlex="grow">
          <mat-label>E-Mail</mat-label>
          <input formControlName="email" matInput required>
          <mat-error *ngIf="form.get('email').hasError('required')">We need an email address to log you in</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="grow">
          <mat-label>Password</mat-label>
          <input [type]="inputType" formControlName="password" matInput required>
          <button (click)="toggleVisibility()" mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button">
            <mat-icon *ngIf="visible" [icIcon]="icVisibility"></mat-icon>
            <mat-icon *ngIf="!visible" [icIcon]="icVisibilityOff"></mat-icon>
          </button>
          <mat-hint>Click the eye to toggle visibility</mat-hint>
          <mat-error *ngIf="form.get('password').hasError('required')">We need a password to log you in</mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="space-between center">
        <mat-checkbox class="caption" color="primary">Remember Me</mat-checkbox>
        <a [routerLink]="['/forgot-password']" class="caption">Forgot Password?</a>
      </div>

      <button (click)="send()" color="primary" mat-raised-button type="button">
        SIGN IN
      </button>

      <p class="text-secondary text-center">
        Don't have an account?<br/>
        <a [routerLink]="['/register']">Click here to create one</a>
      </p>
    </div>
  </div>
</div>
